/** Promotions that come off at the register. */
const offers = {
  en: {
    belowCost: "Sells below what you paid for: {names}. It still applies at the till.",
    title: "Offers",
    subtitle: "Discounts that come off automatically at the register.",
    new: "New offer",
    loadFailed: "Could not load your offers.",
    saveFailed: "Could not save that offer.",
    types: {
      percentage: "Percentage off",
      fixed: "Amount off",
      buy_x_get_y: "Buy some, get some free",
    },
    titleLabel: "Title",
    titlePlaceholder: "e.g. 20% off all juice",
    kind: "Kind",
    buy: "Buy",
    getFree: "Get free",
    needsAll:
      "The customer needs all {count} in the basket before the free one comes off.",
    percentOff: "Percentage off",
    amountOff: "Amount off ({currency})",
    fixedHint: "Comes off the line once, not off every unit.",
    everything: "Everything in the shop",
    searchProduct: "Search a product or a range this applies to…",
    rangeTag: "range",
    rangeHint: "A range covers every variant in it, including ones added later.",
    rangesCount: { one: "{count} range", other: "{count} ranges" },
    coversNothingHint:
      "This offer covers nothing yet, so it will not change any price. Add a product, or tick “everything in the shop”.",
    save: "Save offer",
    none: "No offers yet.",
    live: "live now",
    notRunning: "not running",
    summaryBuyGet: "buy {buy}, get {get}",
    coversNothing: "Covers nothing — this changes no prices",
    pause: "Pause",
    resume: "Resume",
    removeProduct: "Remove {name}",
  },

  fr: {
    belowCost: "Vend en dessous de votre prix d'achat : {names}. Elle s'applique quand même en caisse.",
    title: "Offres",
    subtitle: "Des remises appliquées automatiquement à la caisse.",
    new: "Nouvelle offre",
    loadFailed: "Impossible de charger vos offres.",
    saveFailed: "Impossible d'enregistrer cette offre.",
    types: {
      percentage: "Pourcentage de remise",
      fixed: "Montant de remise",
      buy_x_get_y: "X achetés, Y offerts",
    },
    titleLabel: "Titre",
    titlePlaceholder: "ex. -20 % sur tous les e-liquides",
    kind: "Type",
    buy: "Achetés",
    getFree: "Offerts",
    needsAll:
      "Le client doit avoir les {count} articles dans le panier pour que l'offert soit déduit.",
    percentOff: "Pourcentage de remise",
    amountOff: "Montant de remise ({currency})",
    fixedHint: "Déduit une seule fois sur la ligne, pas sur chaque unité.",
    everything: "Toute la boutique",
    searchProduct: "Rechercher un produit ou une gamme concernés…",
    rangeTag: "gamme",
    rangeHint: "Une gamme couvre toutes ses variantes, y compris celles ajoutées plus tard.",
    rangesCount: { one: "{count} gamme", other: "{count} gammes" },
    coversNothingHint:
      "Cette offre ne couvre encore rien, elle ne changera donc aucun prix. Ajoutez un produit ou cochez « toute la boutique ».",
    save: "Enregistrer l'offre",
    none: "Aucune offre pour l'instant.",
    live: "en cours",
    notRunning: "inactive",
    summaryBuyGet: "{buy} achetés, {get} offerts",
    coversNothing: "Ne couvre rien — aucun prix ne change",
    pause: "Suspendre",
    resume: "Reprendre",
    removeProduct: "Retirer {name}",
  },

  ar: {
    belowCost: "يبيع بأقل من سعر الشراء: {names}. يبقى مطبّقاً في الصندوق.",
    title: "العروض",
    subtitle: "خصومات تُطبَّق تلقائياً في نقطة البيع.",
    new: "عرض جديد",
    loadFailed: "تعذّر تحميل عروضك.",
    saveFailed: "تعذّر حفظ هذا العرض.",
    types: {
      percentage: "خصم بالنسبة",
      fixed: "خصم بمبلغ",
      buy_x_get_y: "اشترِ كمية واحصل على أخرى مجاناً",
    },
    titleLabel: "العنوان",
    titlePlaceholder: "مثال: خصم 20% على كل السوائل",
    kind: "النوع",
    buy: "اشترِ",
    getFree: "مجاناً",
    needsAll: "يجب أن تكون القطع الـ {count} كلها في السلة قبل خصم المجانية.",
    percentOff: "نسبة الخصم",
    amountOff: "مبلغ الخصم ({currency})",
    fixedHint: "يُخصم مرة واحدة من السطر، لا من كل وحدة.",
    everything: "كل منتجات المتجر",
    searchProduct: "ابحث عن منتج أو مجموعة يشملها العرض…",
    rangeTag: "مجموعة",
    rangeHint: "تشمل المجموعة كل أنواعها، بما فيها ما يُضاف لاحقاً.",
    rangesCount: {
      one: "مجموعة واحدة",
      two: "مجموعتان",
      few: "{count} مجموعات",
      many: "{count} مجموعة",
      other: "{count} مجموعة",
    },
    coversNothingHint:
      "هذا العرض لا يشمل أي شيء بعد، لذا لن يغيّر أي سعر. أضف منتجاً أو اختر «كل منتجات المتجر».",
    save: "حفظ العرض",
    none: "لا توجد عروض بعد.",
    live: "سارٍ الآن",
    notRunning: "غير سارٍ",
    summaryBuyGet: "اشترِ {buy} واحصل على {get}",
    coversNothing: "لا يشمل شيئاً — لا يغيّر أي سعر",
    pause: "إيقاف مؤقت",
    resume: "استئناف",
    removeProduct: "إزالة {name}",
  },
};

export default offers;
